import { render, staticRenderFns } from "./xt-tick.vue?vue&type=template&id=2aca8eb6&scoped=true&"
import script from "./xt-tick.vue?vue&type=script&lang=js&"
export * from "./xt-tick.vue?vue&type=script&lang=js&"
import style0 from "./xt-tick.vue?vue&type=style&index=0&id=2aca8eb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca8eb6",
  null
  
)

export default component.exports